const Pen = () => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    width='36'
    height='36'
    viewBox='0 0 36 36'
  >
    <g fill='none' fillRule='evenodd' strokeWidth='1.5'>
      <path d='M3.75 32c0 .138.112.25.25.25h5a.25.25 0 0 0 .177-.073l23-23a.25.25 0 0 0 0-.354l-5-5a.25.25 0 0 0-.354 0l-23 23A.25.25 0 0 0 3.75 27v5zM5 26.5L9.663 31' />
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M8.5 3.75v9.5M3.75 8.5h9.5'
      />
    </g>
  </svg>
);

export default Pen;
